import { render, staticRenderFns } from "./AdminDataCollectionStats.vue?vue&type=template&id=2a5fdf24&scoped=true&"
import script from "./AdminDataCollectionStats.vue?vue&type=script&lang=js&"
export * from "./AdminDataCollectionStats.vue?vue&type=script&lang=js&"
import style0 from "./AdminDataCollectionStats.vue?vue&type=style&index=0&id=2a5fdf24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5fdf24",
  null
  
)

export default component.exports